import { AppRouteRecordRaw } from '../types';

const Body = () => import('@/components/body.vue');
const PortalChangelog = () => import('@/pages/portalchangelog/PortalChangelog.vue');
const ApiPartnerChangelog = () => import('@/pages/portalchangelog/ApiPartnerChangelog.vue');
const FleetPartnerChangelog = () => import('@/pages/portalchangelog/FleetPartnerChangelog.vue');
const EnergyNetworkPartnerChangelog = () =>
  import('@/pages/portalchangelog/EnergyNetworkPartnerChangelog.vue');
const RydInternalChangelog = () => import('@/pages/portalchangelog/RydInternalChangelog.vue');

export const portalChangelogRoutes: AppRouteRecordRaw[] = [
  // TODO: 'pages' level to be removed
  {
    path: '/portal-changelog',
    component: Body,
    meta: {
      headTitle: 'Portal Changelog',
      breadcrumb: 'Portal Information',
    },
    children: [
      {
        path: '',
        name: 'portalChangelog',
        component: PortalChangelog,
        meta: {
          title: 'Portal Changelog | ryd Portal',
          breadcrumb: 'Portal Changelog',
        },
      },
      {
        path: 'api-partner',
        name: 'ApiPartnerChangelog',
        component: ApiPartnerChangelog,
        meta: {
          title: 'Portal Changelog | ryd Portal',
          breadcrumb: 'Portal Changelog',
        },
      },
      {
        path: 'fleet-partner',
        name: 'FleetPartnerChangelog',
        component: FleetPartnerChangelog,
        meta: {
          title: 'Portal Changelog | ryd Portal',
          breadcrumb: 'Portal Changelog',
        },
      },
      {
        path: 'energy-network-partner',
        name: 'EnergyNetworkPartnerChangelog',
        component: EnergyNetworkPartnerChangelog,
        meta: {
          title: 'Energy Network Partner Changelog | ryd Portal',
          breadcrumb: 'Energy Network Partner Changelog',
        },
      },
      {
        path: 'ryd-internal',
        name: 'RydInternalChangelog',
        component: RydInternalChangelog,
        meta: {
          title: 'ryd Internal Changelog | ryd Portal',
          breadcrumb: 'Portal Changelog',
        },
      },
    ],
  },
  // Redirect for backwards compatibility
  {
    path: '/pages/portal-changelog/:pathMatch(.*)*',
    redirect: (to) => {
      return to.path.replace('/pages/portal-changelog', '/portal-changelog');
    },
  },
];
